import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { FDStack, FDImage } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useScrollTopOnMount from 'Hooks/useScrollTopOnMount';
import useEventTrackingLogEvent, { categories, eventSubTypes, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import StepNavigationFooter from 'Packages/FacetDesign/Components/Experimental/StepNavigationFooter';
import { dataAttrs } from 'Helpers/Testing';
import {
  useBuildCommonFQEventProperties,
} from 'Views/FreemiumEntry/HasRelationship/Content/Components/utils';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import { QuizWrapperLayout } from 'Views/FreemiumEntry/HasRelationship/Content/Components/QuizWrapperLayout';
import fr from 'facet-rest';
import { LottieLoadingLayout } from 'Organisms/LottieControl/LottieLoadingLayout';
import { LottieRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/LottieRel';

const InsightProduct = () => {
  const { resource, onSubmit, saving } = useMetaLayoutContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();
  const { buildCommonFQEventProperties } = useBuildCommonFQEventProperties();

  useScrollTopOnMount();

  useBoneBackgroundColor();

  const spacing = 4;

  return (
    <QuizWrapperLayout>
      <FDStack direction={'column'} spacing={2} {...dataAttrs('insight-container')}>
        <FDStack direction={'column'} spacing={spacing}>
          <MetaControlField attr={'insightProductTitle'} />
          <LottieLoadingLayout>
            <FDStack direction={'column'} spacing={spacing}>
              <LottieRel relationship={resource.relationship(fr.relationships.lottie.name)} />
              {resource.withRelationship(fr.relationships.image.name,
                (rel) => (
                  <FDStack direction={'column'} paddingY={4}>
                    <FDImage
                      src={rel.link('related').url()}
                      alt={rel.meta('altText') || ''}
                      aspectRatio={rel.meta('aspectRatio')}
                    />
                  </FDStack>),
                () => null)}
              <MetaControlField attr={'insightProductDescription'} />
              <MetaControlField attr={'infoBoxCollection'} />
            </FDStack>
          </LottieLoadingLayout>
        </FDStack>
        {resource.meta().canPut() && <StepNavigationFooter
          onNext={() => {
            logStandardizedEvent(categories.facetQuiz, eventTypes.insight, eventSubTypes.clickedCTA, {
              eventProperties: {
                ...buildCommonFQEventProperties(resource),
                insightId: resource.attr('insightId'),
                insightReferenceName: resource.attr('insightReferenceName'),
              },
            });
            onSubmit();
          }}
          isLoading={saving}
          label={resource.attr('primaryActionLabel') || 'Continue'}
        />}
      </FDStack>
    </QuizWrapperLayout>
  );
};

export { InsightProduct };
